import { Environment } from '../environments/environment'
import { LocaleId } from '../models'

type Link = string
type LinkLocalized = Record<LocaleId, Link>

interface LinkConfig {
  accessibilityStatement: Link
  privacyPolicy: Link
  rentYourOwnHolidayWeek: LinkLocalized
  serviceTerms: Link
  store: LinkLocalized
  storeServices: Link
  termsOfBookings: LinkLocalized
  termsOfDigitalServices: Link
  termsOfOwnership: Link
  termsOfRental: Link
  webshop: Link
  webshopSignUpComplete: Link
  welcomePresentation: Link
}

/* Query param provided to help syncing sessions */
const LOMA_REFERENCE_QUERY = '?ref=loma'
const DOMAIN = 'https://holidayclubresorts.com'

export const LINK_CONFIG: LinkConfig = {
  accessibilityStatement: `${DOMAIN}/fi/footermenu/verkkopalvelustamme/saavutettavuusseloste-omat-lomasivut${LOMA_REFERENCE_QUERY}`,
  privacyPolicy: `${DOMAIN}/fi/footermenu/verkkopalvelustamme/tietosuoja${LOMA_REFERENCE_QUERY}`,
  rentYourOwnHolidayWeek: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/ownership/viikko-osake/renting-out/${LOMA_REFERENCE_QUERY}`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/omistaminen/viikko-osake/vuokravalitys${LOMA_REFERENCE_QUERY}#lomakkeet`,
  },
  serviceTerms: `${DOMAIN}/fi/footermenu/verkkopalvelustamme/digitaalisten-palveluiden-kayttoehdot${LOMA_REFERENCE_QUERY}`,
  store: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/store${LOMA_REFERENCE_QUERY}`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/store/${LOMA_REFERENCE_QUERY}`,
  },
  storeServices: `${Environment.API.Webshop.url}/fi/store/lisapalvelut-uusi/lista${LOMA_REFERENCE_QUERY}`,
  termsOfBookings: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/booking-terms-and-conditions/terms-and-conditions/${LOMA_REFERENCE_QUERY}`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/varausehdot/yhdistetyt-ehdot/${LOMA_REFERENCE_QUERY}`,
  },
  termsOfDigitalServices: `${Environment.API.Webshop.url}/fi/footermenu/verkkopalvelustamme/digitaalisten-palveluiden-kayttoehdot/${LOMA_REFERENCE_QUERY}`,
  termsOfOwnership: `${Environment.API.Webshop.url}/fi/omistaminen/omistajien-digipalvelut/${LOMA_REFERENCE_QUERY}`,
  termsOfRental: `${Environment.API.Webshop.url}/fi/omistaminen/viikko-osake/vuokravalitys/${LOMA_REFERENCE_QUERY}`,
  webshop: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}`,
  webshopSignUpComplete: `${Environment.API.Webshop.url}/fi/sign-up-complete/${LOMA_REFERENCE_QUERY}`,
  welcomePresentation: `${Environment.API.Webshop.url}/fi/omistaminen/tervetuloa-esittelyyn/${LOMA_REFERENCE_QUERY}`,
}
